export const response_categoria_all = {
  description: 'Categorías obtenidas exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Categorías obtenidas exitosamente' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string', example: '6f417710-1198-40d3-91af-fa1a51943e60' },
            descripcion: { type: 'string', example: 'Ropas' },
            padre: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', example: '8689bede-cd18-440a-8946-106d1ede5517' },
                empresa_id: { type: 'string', example: '7eeeedd9-fa1d-4db5-b2e2-0adf6a39789a' },
                padre_id: { type: 'string', nullable: true, example: null },
                icono: { type: 'string', example: '' },
                descripcion: { type: 'string', example: 'Bebidas heladas' },
                activo: { type: 'boolean', example: true },
                deleted_at: { type: 'boolean', example: false },
                created_at: { type: 'object' },
                updated_at: { type: 'object' },
                usuario: { type: 'object', nullable: true, example: null },
              },
            },
            activo: { type: 'boolean', example: true },
            deleted_at: { type: 'boolean', example: false },
            created_at: { type: 'object' },
            updated_at: { type: 'object' },
            usuario: { type: 'object', nullable: true, example: null },
          },
        },
      },
      total: { type: 'number', example: 3 },
      page: { type: 'number', example: 1 },
      limit: { type: 'number', example: 100 },
      lastPage: { type: 'number', example: 1 },
    },
  },
};
export const response_categoria_find = {
  message: 'Categoría obtenida exitosamente',
  data: {},
};
export const response_categoria_standard = {
  description: 'Categoría creada/actualizada exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Categoría creada exitosamente' },
      data: {
        type: 'object',
        properties: {
          id: { type: 'string', format: 'uuid' },
          empresa_id: { type: 'string', format: 'uuid' },
          padre_id: { type: 'string', format: 'uuid', nullable: true },
          icono: { type: 'string', example: '' },
          descripcion: { type: 'string' },
          activo: { type: 'boolean' },
          deleted_at: { type: 'boolean' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
          usuario: { type: 'string', nullable: true },
        },
      },
    },
  },
};
export const response_categoria_roots = {
  description: 'Categorías padre obtenidas exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Categorías padre obtenidas exitosamente' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string', format: 'uuid', example: '6f417710-1198-40d3-91af-fa1a51943e60' },
            empresa_id: { type: 'string', format: 'uuid', example: '7eeeedd9-fa1d-4db5-b2e2-0adf6a39789a' },
            padre_id: { type: 'string', format: 'uuid', nullable: true, example: null },
            icono: { type: 'string', example: '' },
            descripcion: { type: 'string', example: 'Ropas' },
            activo: { type: 'boolean', example: true },
            deleted_at: { type: 'boolean', example: false },
            created_at: { type: 'object' },
            updated_at: { type: 'object' },
            usuario: { type: 'object', nullable: true, example: null },
          },
        },
      },
    },
  },
};
export const response_categoria_children = {
  description: 'Categorías hijas obtenidas exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Categorías hijas obtenidas exitosamente' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string', format: 'uuid', example: '6f417710-1198-40d3-91af-fa1a51943e60' },
            empresa_id: { type: 'string', format: 'uuid', example: '7eeeedd9-fa1d-4db5-b2e2-0adf6a39789a' },
            padre_id: { type: 'string', format: 'uuid', nullable: true, example: null },
            icono: { type: 'string', example: '' },
            descripcion: { type: 'string', example: 'Ropas' },
            activo: { type: 'boolean', example: true },
            deleted_at: { type: 'boolean', example: false },
            created_at: { type: 'object' },
            updated_at: { type: 'object' },
            usuario: { type: 'object', nullable: true, example: null },
          },
        },
      },
    },
  },
};
